<template>
	<div class="flex flex-col pt-32 justify-center items-center">
		<img class="mb-16 " src="../../assets/images/logo.svg"/>
		<div class="child-div pl-16 pr-16 py-16 rounded-xl shadow-lg flex justify-center items-center flex-col">
			<img src="../../assets/images/delete.svg"/>
			<h1 class="mt-4 text-3xl font-bold leading-9 tracking-normal text-center text-neutral-800">{{ $t('Project not found') }}</h1>
			<p class="mt-2 text-sm font-normal leading-5 tracking-normal text-center text-neutral-600">{{ $t("The project you are looking for doesn't exist anymore") }}</p>
			<a
			  :href="linkUrl"
			  class="
				btn-main
				mt-4"
			  >{{ $t('Go to FeedBear') }}</a>
		</div>
	</div>
</template>

<script>
	export default {
		props:['link-url'],
	}
</script>
<style scoped>
</style>